module.exports = __webpack_public_path__ + "src/assets/img/train.27049e28.svg";